/**
 * KAN-1003: пояснения страницы цен. Сами цены и границы пополнения приходят из
 * GET /api/v1/public/prices/, здесь только постоянный текст.
 */
import type { LegalParagraph } from './types';
import { SERVICE_NAME, SERVICE_SITE, SUPPORT_EMAIL_LINK, TERMS_LINK } from './support';

export const PRICES_TITLE = 'Цены';

export const PRICES_INTRO = `Актуальные цены сервиса "${SERVICE_NAME}" (${SERVICE_SITE}). Цены в рублях, с наценкой платформы.`;

export const PRICES_HOW_IT_WORKS: readonly LegalParagraph[] = [
  'Тарифов нет, все функции открыты. Вы пополняете рублёвый кошелёк кабинета, а сервис списывает с него фактический расход по ценам выше.',
  'Текстовый ИИ и голосовой ИИ: цена указана за $1 стоимости у провайдера нейросети. Списание равно стоимости ответа или разговора у провайдера в долларах, умноженной на цену строки.',
  'Телефония: цена за минуту разговора.',
  'Каждое списание видно в кабинете в разделе "Баланс". Когда баланс заканчивается, платные действия приостанавливаются до пополнения.',
];

export const PRICES_PAYMENT: readonly LegalParagraph[] = [
  'Оплата банковской картой или через СБП через платёжный сервис ЮKassa. Кассовый чек по 54-ФЗ направляется на e-mail, указанный при оплате.',
  ['Юридические лица и предприниматели могут оплатить по счёту (безналичный расчёт): напишите в поддержку ', SUPPORT_EMAIL_LINK, '.'],
  ['Неизрасходованный остаток возвращается по обращению в поддержку, подробнее в документе ', TERMS_LINK, ', раздел 5.'],
];
